import { ref, nextTick } from 'vue';
import router from '@/router';
import axios from 'axios'
import QRCode from 'qrcode';
import { AccountType } from './userData';
import type { JSONContent } from '@tiptap/vue-3';
//URLS
export const staticURL = (route: string) => {
  return `${import.meta.env.VITE_STATIC_BASE}/${route}`
}
export const backendURL = (route: string) => {
  return `${import.meta.env.VITE_API_BASE}/${route}`
}
export const assetURL = (route: string) => {
  return `https://assets.doored.app/${route}`
}
export const profileAsset = (route: string) => {
  return `https://user-assets.doored.app/${route}`
}
export const getPusherClientKey = () => {
  return `${import.meta.env.VITE_PUSHER_CLIENT_KEY}`
}
//User
export const raceTries = ref<number>(0);
export enum AccountPermissionType {
  FREE='free',
  BUILD='build',
  PREPPACK='prep_pack'
}
export enum RegisterStages {
  OPTIONS = 'internship_options',
  SPRING_PACKS = 'spring_packs',
  SUMMER_PACKS = 'summer_packs',
  SPRING_BUILD = 'spring_build',
  SUMMER_BUILD = 'summer_build',
  SPRING_FORM = 'spring_form',
  SUMMER_FORM = 'summer_form',
  SPRING_2FA = 'spring_2fa',
  SUMMER_2FA = 'summer_2fa',
  SPRING_PAY = 'spring_pay',
  SUMMER_PAY = 'summer_pay',
  PAY_SUCCEDED = 'pay_succeeded',
  PAY_FAILED = 'pay_failed',
  BUILD_UPGRADE = 'build_upgrade',
  PACK_UPGRADE = 'pack_upgrade',

  BUILD_GRADUATE = 'build_graduate',
  PACK_GRADUATE = 'pack_graduate'
}
export interface RegisterStageData {
    title: string
    previousStage: RegisterStages
    options?: string[]
}
export enum RegisterRedirects {
  NONE = '',
  PayAttempted = 'payment_attempted',
  BuiltSpring = 'built-spring',
  BuiltSummer = 'built-summer',
  ChoseSpring = 'spring',
  ChoseSummer = 'summer',
  ChoseSpringPack = 'spring-pack',
  ChoseSummerPack = 'summer-pack',
  BuildUpgrade = 'build_upgrade',
  UpgradeToPack = 'pack_upgrade',
  // SeoSpringSignup = 'seo-spring',
  // SeoSummerSignup = 'seo-summer',

  ChosePackGraduate = 'graduate_pack',
  ChoseBuildGraduate = 'graduate_build',
}
export function generateQR(uri: string) {
    const canvas = document.getElementById('qrcode-canvas') as HTMLCanvasElement;
    if (!canvas) {
        console.error("Canvas not found!");
        return;
    }
    QRCode.toCanvas(canvas, uri, { width: 124, color: {dark: '#333333', light: "#fafafa"}, errorCorrectionLevel: 'H' }, (error: Error) => {
        if (error) console.error(error);
        else console.log('QR code generated!');
    });
}

export const genQR = () => {
    generateQR('otpauth://totp/MyWebApp:user@example.com?secret=JBSWY3DPEHPK3PXP&issuer=MyWebApp')
}

export const clearRegisterCache = () => {
  localStorage.removeItem('email');
  localStorage.removeItem('username');
  localStorage.removeItem('password');
  localStorage.removeItem('fingerprint');
  localStorage.removeItem('jwt');
  localStorage.removeItem('twofa_input');
  localStorage.removeItem('twofa_uri');
  localStorage.removeItem('twofa_secret');
  localStorage.removeItem('cached_pack');
  localStorage.removeItem('permission');
  localStorage.removeItem('account_type');
  localStorage.removeItem('current_stage');
  localStorage.removeItem('applied_promo_code');
  localStorage.removeItem('promo_code');
  localStorage.removeItem('discount_pct');
  localStorage.removeItem('show_recovery');
  localStorage.removeItem('recovery_codes');
  // masterLoginState keys
  localStorage.removeItem('seeLogin');
  localStorage.removeItem('seeForget');
  localStorage.removeItem('see2FA');
  localStorage.removeItem('useRecoveryCode');
  localStorage.removeItem('recoveryCodeAccepted');
  localStorage.removeItem('showRotationWarning');
  localStorage.removeItem('see2FASetup');
  localStorage.removeItem('showSetupRecoveryCodes');
  // masterLoginData keys
  localStorage.removeItem('setup_jwt');
  localStorage.removeItem('setup_uri');
  localStorage.removeItem('twofa_setup_otp');
  localStorage.removeItem('twofa_input_code');
  localStorage.removeItem('twofaRecoveryCode');
  localStorage.removeItem('recovery_jwt');
  localStorage.removeItem('twofaRecoveryUri');
  localStorage.removeItem('recoveryTwofaInput');
  localStorage.removeItem('forgottenPasswordEmail');
}

export interface PackDataType {
  number_of_firms: number
  price: number
  firms: number[]
}

export const LoginComponentMode = {LOGIN: 'login', UPDATE_PASSWORD: 'update_password'} as const;
export type LoginComponentModeType = typeof LoginComponentMode[keyof typeof LoginComponentMode]

export interface LoginData {
  email: string
  password: string
  remember: boolean
  fingerprint: string
}

export async function loginRequest(data: LoginData) {
  return await fetch(backendURL('auth/login/email'), {
    method: 'POST',
    credentials: 'include',
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(data)
  })
}

export async function signWithGoogle(clearCache: boolean) {
  if (clearCache) {
    clearRegisterCache();
    await nextTick(); 
  }
  const starter = `${import.meta.env.VITE_API_BASE}/auth/login/google`;
  window.location.href = starter;
}

export interface Achievement {
    title: string
    badge: string
    image: string
    achieved_at: string | Date
    fill?: boolean
}

//Small app ui helpers
export const showUserSearch = ref<boolean>(false)
export const followerUserSearch = ref<boolean>(false)
export const showInviteModal = ref<boolean>(false)
export const allowSideHover = ref<boolean>(true)
export const inspectingPost = ref<boolean>(false)
export const creatingSelected = ref<boolean>(false)
export const showTip = ref<boolean>(false)
export const newCom = ref<boolean>(false)
export const notifyNew = ref<boolean>(false)

export interface userAlert {
  title?: string
  msg?: string
  type?: string
}

//forums
export interface postData {
  id: number
  user_id: number
  username: string
  profile_image: string
  account_type: AccountType|string
  title: string
  tags: string[]
  preview_image_url: string
  upvotes_count: number
  comments_count: number
  posted_date: string | Date
  liked_by_user: boolean
  saved_by_user: boolean
  commented_by_user: boolean
}

export async function like(post_id: number) {
  const path = `${import.meta.env.VITE_API_BASE}/forums/posts/like/?id=${post_id}`
  try {
    const res = await axios.put(path, null, {withCredentials: true})
    if (res.status !== 200) {throw new Error("Couldn't like post")}
  } catch (error) {
    return 'error'
  }
}
export async function dislike(post_id: number) {
  const path = `${import.meta.env.VITE_API_BASE}/forums/posts/dislike/?id=${post_id}`
  try {
    const res = await axios.delete(path, {withCredentials: true})
    if (res.status !== 200) {throw new Error("Error disliking post")}
  } catch (error) {
    return 'error'
  }
}
export const handleLike = async (data: postData) => {
    if (!data.liked_by_user) {
      try {
        await like(data.id)
        data.liked_by_user = true;
      } catch {
        data.liked_by_user = false;
      }
    } else if (data.liked_by_user) {
      try {
        await dislike(data.id)
        data.liked_by_user = false
      } catch {
        data.liked_by_user = true
      }
    }
}
export const selectedPost = ref<postData | undefined>()

async function save(post_id: number) {
  const path = `${import.meta.env.VITE_API_BASE}/forums/posts/save/?id=${post_id}`
  try {
    const res = await axios.put(path, null, {withCredentials: true})
    if (res.status !== 200) {throw new Error("Couldn't save post")}
  } catch (error) {
    return 'error'
  }
}
async function unsave(post_id: number) {
  const path = `${import.meta.env.VITE_API_BASE}/forums/posts/unsave/?id=${post_id}`
  try {
    const res = await axios.delete(path, {withCredentials: true})
    if (res.status !== 200) {throw new Error("Error unsaving post")}
  } catch (error) {
    return 'error'
  }
}
export const saveLoad = ref<Record<number, boolean>>({})
export const handleSave = async (data: postData) => {
  if (!data.saved_by_user) {
    try {
      saveLoad.value[data.id] = true
      await save(data.id)
      setTimeout(() => {
        saveLoad.value[data.id] = false
        data.saved_by_user = true
      }, 150)
    } catch {
      saveLoad.value[data.id] = false
      data.saved_by_user = false
    }
  } else if (data.saved_by_user) {
    try {
      saveLoad.value[data.id] = true
      await unsave(data.id)
      setTimeout(() => {
        saveLoad.value[data.id] = false
        data.saved_by_user = false;
      }, 150)
    } catch {
      saveLoad.value[data.id] = false
      data.saved_by_user = true
    }
  }
}

export async function authenticatedFetch(url: string, options: RequestInit = {}) {
  const fetchOptions: RequestInit = {
    credentials: 'include',
    ...options
  };

  try {
    const response = await fetch(url, fetchOptions);
    
    if (response.status === 401) {
      const { useUserStore } = await import('./userData')
      const userStore = useUserStore();
      userStore.setUser(null);
      console.log('Session expired, redirecting to login...');
      router.push('/login');
      return new Response(JSON.stringify({}), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    return response;
  } catch (error) {
    console.log('Network error occurred, redirecting to login...', error);
    
    
    router.push('/login');
    
    return new Response(null, { 
      status: 200, 
      statusText: 'Network error - Redirecting to login' 
    });
  }
}

export interface postRequestMetaData {
  title: string
  tags: string[]
}

export interface commentRequestMetaData {
  post_id: number
  parent_id: number|null
}

export interface Comment {
    id: number
    parent_id: number|null
    username: string
    profile_image: string
    content: JSONContent
    posted_date: Date|string
}

export interface StructuredComment extends Comment {
    children: StructuredComment[]
}

export interface BasicPusherEvent {
  post_id: number
}

export interface ExtendedPusherEvent extends BasicPusherEvent {
  new_count: number
}

export const showUpgradeModal = ref<boolean>(false);
export const showAchievementsModal = ref<boolean>(false);
export const showAccountRotateModal = ref<boolean>(false);